export enum URLType {
  BU = "BU",
  CG = "CG",
  CR = "CR",
  AR = "AR",
  CA = "CA",
}
